// For now all of our help links lead to the same destination.
// In the future we will build out this help document with sections for each piece of content.
// eslint-disable-next-line @trello/export-matches-filename
export enum AtlassianAccountOnboardingLinks {
  Help = 'https://help.trello.com/article/1186-managed-atlassian-accounts-for-trello',
  HelpV2 = 'https://help.trello.com/article/1186-managed-atlassian-accounts-for-trello',
  AtlassianAccount = 'https://help.trello.com/article/1186-managed-atlassian-accounts-for-trello',
  TransferBoards = '/support/transfer-boards',
  Signup = 'https://help.trello.com/article/1186-managed-atlassian-accounts-for-trello',
}
